import React from 'react'
import { SearchOutlined } from '@ant-design/icons'
import { Button, Tooltip, Flex } from 'antd'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { setGoBackToVehicleTest } from '../actions/go-to-vehicle-test'
import { useDispatch } from 'react-redux'

export const GlobalSearchButton = ({
  vin = null,
  showVINInTooltip = false,
  disabled = false,
}) => {
  const history = useHistory()
  const intl = useIntl()
  const dispatch = useDispatch()
  const vehicleTestRouteMatch = useRouteMatch('/tracer/:pathId') // Vehicle Test Session Route

  return (
    <Flex gap="small" align="center">
      <Tooltip
        title={
          vin && showVINInTooltip
            ? intl.formatMessage(
                { id: 'globalSearch.buttonTootipVINText' },
                {
                  vin,
                },
              )
            : intl.formatMessage({ id: 'globalSearch.buttonTootipText' })
        }
      >
        <Button
          color="primary"
          size="large"
          icon={<SearchOutlined />}
          onClick={() => {
            vehicleTestRouteMatch &&
              dispatch(
                setGoBackToVehicleTest({
                  pathname: vehicleTestRouteMatch.url,
                  vin,
                }),
              )
            vin
              ? history.push(`/global-search/vin/${vin}`)
              : history.push('/global-search/configuration')
          }}
          disabled={disabled}
        />
      </Tooltip>
    </Flex>
  )
}
